import { render, staticRenderFns } from "./testOrderListing.vue?vue&type=template&id=2bb97275&"
import script from "./testOrderListing.vue?vue&type=script&lang=js&"
export * from "./testOrderListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports